module.exports = __webpack_public_path__ + "static/media/asepsis-logo.66c14fa4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/asepsis-logo.svg
// module id = 499
// module chunks = 0